import React from "react";
import { Link } from "react-router-dom";

/**
 * Reusable GalerieCop wordmark with the TM.
 * Sizes:
 *   - "sm"   -> small top-corner mark (guest pages, floating overlays)
 *   - "md"   -> default nav header
 *   - "lg"   -> large hero variants
 * Variants (tint):
 *   - "coral" (default) — coral wordmark on light backgrounds
 *   - "white"           — white wordmark on dark backgrounds (highlights hero)
 * Renders as a <Link to="/"> unless `asStatic` is true (e.g. inside a guest
 * page where a link home might confuse a mid-upload guest).
 */
const SIZE_MAP = {
  sm: { word: "text-[22px]", tm: "text-[10px] mt-0.5" },
  md: { word: "text-[34px]", tm: "text-xs mt-1" },
  lg: { word: "text-[46px]", tm: "text-sm mt-1.5" },
};

const TINT_MAP = {
  coral: "text-coral-300",
  white: "text-white",
  navy: "text-navy-700",
};

export const Logo = ({ size = "md", tint = "coral", asStatic = false, className = "", ...rest }) => {
  const s = SIZE_MAP[size] || SIZE_MAP.md;
  const t = TINT_MAP[tint] || TINT_MAP.coral;
  const inner = (
    <span
      className={`inline-flex items-center leading-none ${t} ${className}`}
      data-testid={`galeriecop-logo-${size}`}
      {...rest}
    >
      <span className={`${s.word} font-serif italic font-semibold tracking-tight leading-none`}>
        galeriecop
      </span>
      <span className={`${s.tm} ml-0.5`}>TM</span>
    </span>
  );
  if (asStatic) return inner;
  return (
    <Link to="/" aria-label="GalerieCop home" className="inline-flex items-center">
      {inner}
    </Link>
  );
};

export default Logo;
